//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmptyBox from '@/components/views/empty_box'
const TABS_TYPE = {
    '取证消息': {
        key: 'forensics',
        name: '取证消息'
    },
    '复核结果': {
        key: 'result',
        name: '复核结果'
    },
    '摇号结果': {
        key: 'lottery',
        name: '摇号结果'
    },
    '收到的回复': {
        key: 'reply',
        name: '收到的回复'
    },
    '收到的点赞': {
        key: 'give_like',
        name: '收到的点赞'
    },
    '购房答疑': {
        key: 'questions',
        name: '购房答疑'
    },
    '反馈消息': {
        key: 'feedback',
        name: '反馈消息'
    },
    '楼盘动态': {
        key: 'buildings',
        name: '楼盘动态'
    },
    '公众号动态': {
        key: 'public',
        name: '公众号动态'
    },
    '活动消息': {
        key: 'activity',
        name: '通通速递'
    },
    '置业顾问通知': {
        key: 'con',
        name: '置业顾问通知'
    },
    '邀请评论': {
        key: 'invite',
        name: '邀请评论'
    }
}
import Item from '../_components/message_list_item'
import CardLike from '../_message_list/_card_like'

import Service from '@/service/chat_list'
import PublicService from '@/service/public'
import ConsultantService from '@/service/consultant'

import Pagination from '@/common/mixins/pagination'
import Tabs from './_components/_tab'


import Comments from '../_message_list/_comments'
import { App_User } from '@/data/user_info'

import { checkTabBar } from '@/common/utils/check'

export default {
    mixins: [
        Pagination
    ],
    async mounted() {
        const { category, tab_name } = this.$route.query
        this.category = category || ''
        const tab = TABS_TYPE[tab_name]
        this.tab_name = tab ? tab_name : ''
        const { is_consultant } = await App_User.get()
        this.is_consultant = is_consultant
        this.getData(true)
    },
    data() {
        return {
            is_consultant: false,
            per: 10,
            items: [],
            category: '',
            tabs: [],
            loading: true,
            tab_name: '',
            selected_index: '',
            like_tabs: [
                {
                    name: '名片点赞',
                    unread_count: 0
                },
                {
                    name: '评论点赞',
                    unread_count: 0
                }
            ],
            like_tab_index: 0
        }
    },
    computed: {
        selected_tab() {
            return this.tabs.length ? this.tabs[this.selected_index].key : ''
        },
        show_likes () {
            return this.tab_name === '收到的点赞'
        },
        show_card_likes () {
            return this.is_consultant && this.show_likes && this.like_tabs[this.like_tab_index] && this.like_tabs[this.like_tab_index].name === '名片点赞'
        }
    },
    components: {
        Item,
        Tabs,
        EmptyBox,

        Comments,
        CardLike,
    },
    methods: {
        changeLikeTab (index) {
            this.like_tab_index = index
            this.page = 1
            this.items = []
            this.getData()
        },
        goJump(item) {
            this.setLog(item)
            const {jump_path, details, subject, message_type} = item
            if (jump_path) {
                wx[checkTabBar(jump_path) ? 'switchTab' : 'navigateTo']({
                    url: jump_path
                })
            } else if(details.image_url) {
                wx.navigateTo({
                    url: `/list/message_list/save_img?img=${encodeURIComponent(details.image_url)}&subject=${encodeURIComponent(subject)}`
                })
            } else if (message_type === 'yesterday_score_journals') {
                wx.navigateTo({
                    url: `/list/message_list/score_list?occur_date=${details.occur_date}`
                })
            } else if (message_type === 'consultant_resign_apply'){
                wx.navigateTo({
                    url: `/list/message_list/feedback?id=${item.id}&name=${details.building_name}&wx=${details.wx_acount}`
                })
            }
        },
        setLog(item) {
            const { message_type } = item
            if (this.tab_name === '邀请评论') {
                this.$sendCtmEvtLog('消息通知-邀请评论-点击查看')
            } else if (message_type === 'yesterday_score_journals') {
                this.$sendCtmEvtLog('消息通知-置业顾问通知-点击查看积分明细')
            }
        },
        async getData(init = false) {
            console.error('getData')
            this.loading = true
            const params = {
                page: this.page,
                per: this.per,
                category: this.category,
            }
            if (this.tab_name) {
                params.tab_name = this.tab_name
            }
            const data = await Service.getChatList(params)
            let items = this.selected_tab === 'public' ? this.mapPublicItem(data.items) : data.items
            let tabs = data.tabs
            if (init && tabs) {
                tabs.forEach((element, index) => {
                    const tab = TABS_TYPE[element.name]
                    element.key = tab.key
                    element.origin_name = element.name
                    element.name = tab.name
                    if (this.tab_name && this.tab_name === element.origin_name) {
                        this.selected_index = index
                    }
                    if (this.show_likes && element.name === '收到的点赞') {
                        const { message_types } = element
                        this.like_tabs.forEach((tab) => {
                            message_types.some((item) => {
                                if (item.message_type === tab.name) {
                                    tab.unread_count = item.unread_count
                                    return true
                                }
                            })
                        })
                    }
                })
                if (!this.tab_name) {
                    this.selected_index = 0
                    this.tab_name = tabs[0].origin_name
                }
                this.tabs = tabs
            }
            this.$nextTick(() => {
                if (this.show_card_likes) {
                    this.getCardLike()
                } else {
                    this.handleData({items})
                    this.read()
                    this.loading = false
                }
            })
        },
        async getCardLike () {
            const data = await ConsultantService.getCardLikes({
                page: this.page,
                per: this.per
            })
            console.log('getCardLikes', data)
            const { items } = data
            this.handleData({items})
            this.loading = false
            if (data.items && data.items.length) {
                await PublicService.readHints(data.items[0].id, 'Fc::ConsultantCardLike')
                if (this.like_tabs && this.like_tabs.length) {
                    const tab = this.tabs[this.selected_index]
                    tab.unread_count -= this.like_tabs[0].unread_count
                    this.like_tabs[0].unread_count = 0
                }
            }
        },
        mapPublicItem(items) {
            items.forEach(element => {
                element.content_body = element.details || []
                element.published_date = element.details ? element.details.published_date : ''
                element.content_body.image_url = element.details ? element.details.cover_image_url : ''
                element.author = element.details ? element.details.author : ''
            })
            return items
        },
        changeTab(key, name, index) {
            this.selected_index = index
            this.tab_name = this.tabs[index].origin_name
            this.page = 1
            this.items = []
            this.getData()
        },
        read() {
            const tab = this.tabs[this.selected_index]
            const _count = tab ? tab.unread_count : 0
            if (_count > 0) {
                const params = {
                    category: this.category,
                    tab_name: this.tab_name
                }
                Service.readAllUserMessages(params)
                if (this.show_likes) {
                    if (this.like_tabs && this.like_tabs.length) {
                        tab.unread_count -= this.like_tabs[1].unread_count
                        this.like_tabs[1].unread_count = 0
                    }
                } else {
                    tab.unread_count = 0
                }
            }
        }
    }
}
